import {
	getCity
} from '@/api/address';
import Cookies from 'js-cookie'

const state = {
	// 城市id
	city: "",
	tree:[],

	// 语言包
	lang: "zh-cn",

	//首页浮层广告弹出次数
	indexFloatLayerNum: 0,

	//广告显示次数
	indexTopAdNum: 0,

	// 定位区域
	locationRegion: null,
	sidebar: {
		opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
		withoutAnimation: false
	},
	device: 'desktop',

}

const mutations = {
	SET_CITY: (state, value) => {
		state.city = value;
	},
	SET_TREE: (state, value) => {
		state.tree = value;
	},
	SET_LANG: (state, value) => {
		state.lang = value;
	},
	SET_FLOAT_LAYER: (state, value) => {
		state.indexFloatLayerNum = value;
	},
	SET_INDEXTOPADNUM: (state, value) => {
		state.indexTopAdNum = value;
	},
	SET_LOCATION_REGION: (state, value) => {
		state.locationRegion = value;
	},
	TOGGLE_SIDEBAR: state => {
		state.sidebar.opened = !state.sidebar.opened
		state.sidebar.withoutAnimation = false
		if (state.sidebar.opened) {
			Cookies.set('sidebarStatus', 1)
		} else {
			Cookies.set('sidebarStatus', 0)
		}
	},
	CLOSE_SIDEBAR: (state, withoutAnimation) => {
		Cookies.set('sidebarStatus', 0)
		state.sidebar.opened = false
		state.sidebar.withoutAnimation = withoutAnimation
	},
	TOGGLE_DEVICE: (state, device) => {
		state.device = device
	},
}

const actions = {
	setCity({
		commit
	}, value) {
		commit('SET_CITY', value)
	},
	tree({
		commit
	}, value) {
		commit('SET_TREE', value)
	},
	lang({
		commit
	}, value) {
		commit('SET_LANG', value)
	},
	get_city({
		commit
	}, item) {
		return new Promise((resolve, reject) => {
			return getCity({}).then(res => {
				resolve(res)
			}).catch(err => {
				reject(err)
			})
		})
	},
	toggleSideBar({ commit }) {
		commit('TOGGLE_SIDEBAR')
	},
	closeSideBar({ commit }, { withoutAnimation }) {
		commit('CLOSE_SIDEBAR', withoutAnimation)
	},
	toggleDevice({ commit }, device) {
		commit('TOGGLE_DEVICE', device)
	},
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
